import React from "react";
import "./Footer.scss";
const Footer = () => {
  return (
    <footer>
      <p>Designed and Developed by Kishore</p>
    </footer>
  );
};

export default Footer;
